import { FC } from "react";
import { Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";

interface CustomRangeSelectionProps {
  startDate: string;
  endDate?: string;
  noEndDate?: boolean;
  isEdit: boolean;
  onStartDateChange(date: any): void;
  onEndDateChange(date: any): void;
  noEndDateChangeHandler(date: any): void;
}

export const CustomRangeSelection: FC<CustomRangeSelectionProps> = ({
  startDate,
  endDate,
  noEndDate,
  isEdit,
  onStartDateChange,
  onEndDateChange,
  noEndDateChangeHandler,
}) => {
  return (
    <Stack spacing={0.5} width="100%">
      <Stack direction="row" gap={1} width="100%">
        <DatePicker
          format="DD/MM/YYYY"
          value={moment(startDate)}
          label="From"
          disabled={isEdit}
          minDate={moment().subtract(2, "year")}
          onChange={onStartDateChange}
          sx={{ width: "50%" }}
          slotProps={{
            textField: {
              fullWidth: true,
              placeholder: "From",
              size: "small",
              variant: "outlined",
              name: "value",
            },
          }}
        />
        {!noEndDate && (
          <DatePicker
            format="DD/MM/YYYY"
            value={moment(endDate)}
            label="To"
            disabled={isEdit}
            minDate={moment(startDate)}
            onChange={onEndDateChange}
            sx={{ flex: 1 }}
            slotProps={{
              textField: {
                fullWidth: true,
                placeholder: "To",
                size: "small",
                variant: "outlined",
                name: "value",
              },
            }}
          />
        )}
      </Stack>

      <Stack pl={1} direction="row" gap={0.5} alignItems="center">
        <FormControlLabel
          sx={{ mr: 0, flexShrink: 0 }}
          control={
            <Checkbox
              name="receive_updates"
              checked={noEndDate}
              onChange={noEndDateChangeHandler}
              disabled={isEdit}
            />
          }
          label={
            <Typography color={isEdit ? "text.secondary" : "text.primary"}>
              No end date
            </Typography>
          }
        />
      </Stack>
    </Stack>
  );
};
